import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lds-auto-unsubscribe',
  template: ''
})
export class AutoUnsubscribeComponent implements OnDestroy {
  protected subscriptions: Subscription[] = [];

  protected addSubscriptions(...subs: Subscription[]): void {
    this.subscriptions.push(...subs);
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }
}
